export interface Leverages {
  [leverage: number]: {
    text: string;
    error?: string;
  };
}

export interface LeverageSettingsResponse {
  current: number;
  max: number;
  isAvailableChange: boolean;
  nextChangeTime: Date;
  nextChangeTimeUTC: number;
  availables: Leverages;
  hasOpenOrders: boolean;
}

// for front-end
export class LeverageSettings {
  public isLocked: boolean; // true, when 0 or 1 leverages are available
  public current: number;
  public max: number;
  public isAvailableChange: boolean;
  public nextChangeTime: Date;
  public nextChangeTimeUTC: number;
  public availables: Leverages;
  public hasOpenOrders: boolean;

  public static fromDTO(dto: LeverageSettingsResponse): LeverageSettings {
    const settings: LeverageSettings = Object.assign(
      { isLocked: Object.keys(dto.availables).length <= 1 },
      dto,
    );
    Object.keys(settings.availables).forEach(leverage => {
      settings.availables[leverage] = {
        text: settings.availables[leverage]
      };
    });
    return settings;
  }
}
